import React, { useEffect, useState } from 'react'
import qs from 'qs'
import styled from 'styled-components'
import { Auth, Login as LoginOTP, stages } from '@staccx/open-id'
import { UserManager } from 'oidc-client'
import { Button, Input, ItemGroup, Layout } from '@staccx/bento'
import Alert from '../../../components/Alert'
import { TranslatedText } from '@staccx/i18n'
import { Link } from 'react-router-dom'
import Logo from '../../../icons/Logo'
import SignalSpinnerLoader from '../../../components/loaders/SignalSpinnerLoader'
const axios = require('axios')

const oidcConfig = {
  authority: process.env.REACT_APP_AUTOPLAN_OIDC_URL || 'https://oidc.dev.autoplan.staccflow.com',
  client_id: 'autoplan',
  redirect_uri: window.location.protocol + '//' + window.location.host + '/callback-login',
  response_type: 'id_token token',
  scope: 'openid fleet drivers usage invoice user',
  silent_redirect_uri: window.location.protocol + '//' + window.location.host + '/callback-login-silent',
  post_logout_redirect_uri: window.location.protocol + '//' + window.location.host + '/callback-logout',
  automaticSilentRenew: true,
  clockSkew: 600,
}

if (window.location.hostname !== 'localhost' && window.location.hostname !== '10.0.2.2') {
  const hostParts = window.location.host.split('.')
  hostParts.splice(0, 1, 'oidc')
  oidcConfig.authority = `https://${hostParts.join('.')}`
}

const configEmail = {
  acrValue: 'magic-link-email-provider',
  codePostUri: '/api/magic-link-email/magic-link',
  idPostUri: '/api/magic-link-email/request-link',
  callbackPath: '/callback/magic-link-email-provider',
  magicPollUri: '/api/magic-link-email/magic-link-completed',
}

const configSms = {
  acrValue: 'magic-link-sms-provider',
  codePostUri: '/api/magic-link-sms/magic-link',
  idPostUri: '/api/magic-link-sms/request-link',
  callbackPath: '/callback/magic-link-sms-provider',
  magicPollUri: '',
}

const configUsername = {
  acrValue: 'username-password-provider-web',
  codePostUri: '/api/username-password-web/login',
  callbackPath: '/callback/username-password-provider-web',
}

const baseConfig = {
  oidcConfig,
  redirectAfterLogin: '/',
}

export const authService = new Auth(oidcConfig, true)
const redirectStages = [
  stages.errorDuringLogin,
  stages.tooManyAttempts,
  stages.failedToSubmitCode,
  stages.alreadySucceeded,
]

const newUserManager = new UserManager(oidcConfig)
const Login = ({ type = 'small' }) => {
  const searchParams = qs.parse(window.location.search, {
    ignoreQueryPrefix: true,
  })

  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState(null)

  let config = null

  if (type === 'email') {
    config = { ...baseConfig, ...configEmail }
  } else if (type === 'sms') {
    config = { ...baseConfig, ...configSms }
  } else if (type === 'username') {
    config = { ...baseConfig, ...configUsername }
  } else {
    config = { ...baseConfig, ...configSms }
  }

  const submitCredentials = () => {
    const payload = {
      username,
      password,
      state: searchParams.state,
    }
    axios
      .post(config.codePostUri, payload)
      .then((response) => {
        console.log(response)
        window.location.replace(
          ''
            .concat(oidcConfig.authority)
            .concat(config.callbackPath, '?')
            .concat(
              qs.stringify({
                state: searchParams.state,
              }),
            ),
        )
      })
      .catch((error) => {
        setError('En feil oppstod. Prøv igjen')
        console.error('Error during credentials submission:', error)
      })
  }

  const isEmailOrSms = type === 'email' || type === 'sms'
  useEffect(() => {
    const isCallback = oidcConfig.redirect_uri.endsWith(window.location.pathname)
    if (!searchParams.state && !isCallback && type === 'username') {
      const userManager = new UserManager(oidcConfig)
      userManager.signinRedirect({ acr_values: `idp:${config.acrValue}` }).catch(console.error)
    }
  }, [searchParams.state, config.acrValue])

  useEffect(() => {
    sessionStorage.removeItem('loggedoutReason')
  }, [])

  useEffect(() => {
    const isCallback = oidcConfig.redirect_uri.endsWith(window.location.pathname)

    if (isCallback) {
      if (type === 'username') {
        newUserManager
          .signinRedirectCallback()
          .then(() => {
            console.log('Username login successful')
            window.location.replace(config.redirectAfterLogin)
          })
          .catch(function (error) {
            console.error('Error during sign-in redirect callback:', error)
          })
      }
    }
  }, [window.location.pathname, config.redirectAfterLogin])

  return (
    <>
      {isEmailOrSms && (
        <LoginOTP oidcConfig={oidcConfig} {...config}>
          {({ lastError, stage, handleIdInput, handleCodeInput, submitCode, submitId }) => {
            if (redirectStages.includes(stage)) {
              window.location.replace('/')
            }
            if ([stages.submittingCode, stages.waitingForState, stages.submittingId, void 0].includes(stage)) {
              return (
                <Layout>
                  <Center>
                    <SignalSpinnerLoader />
                  </Center>
                </Layout>
              )
            }

            return (
              <React.Fragment>
                {stage === stages.waitingForCode && (
                  <form
                    onSubmit={(e) => {
                      sessionStorage.setItem('type', type)
                      submitCode(e)
                    }}
                  >
                    <Layout>
                      <Center>
                        <Logo />
                      </Center>
                      <Input autoFocus onChange={handleCodeInput} id="loggin" label="Engangskode" />
                      {lastError && (
                        <TranslatedText i18nKey={lastError}>
                          {(value) => <Alert type={'warning'}>{value}</Alert>}
                        </TranslatedText>
                      )}

                      <Button variant="primary" type="submit">
                        {'Logg inn'}
                      </Button>
                      {type === 'email' && (
                        <TranslatedText i18nKey="MAGICLINK_CODE_MESSAGE_EMAIL">
                          {(value) => <CodeMessage>{value}</CodeMessage>}
                        </TranslatedText>
                      )}
                      {type === 'sms' && (
                        <TranslatedText i18nKey="MAGICLINK_CODE_MESSAGE_SMS">
                          {(value) => <CodeMessage>{value}</CodeMessage>}
                        </TranslatedText>
                      )}
                    </Layout>
                  </form>
                )}

                {stage === stages.waitingForId && (
                  <form onSubmit={submitId}>
                    <Layout>
                      <Center>
                        <Logo />
                      </Center>
                      <TranslatedText i18nKey={type === 'sms' ? 'LOGIN_PHONE_INPUT_LABEL' : 'LOGIN_EMAIL_INPUT_LABEL'}>
                        {(value) =>
                          type === 'sms' ? (
                            <Input
                              mode="phone"
                              autoFocus
                              id="loggin"
                              onChange={(e) =>
                                handleIdInput({
                                  target: { value: e.rawValue },
                                })
                              }
                              label={value}
                            />
                          ) : (
                            <Input id="loggin" autoFocus onChange={handleIdInput} label={value} />
                          )
                        }
                      </TranslatedText>

                      {lastError && (
                        <TranslatedText i18nKey={lastError}>
                          {(value) => <Alert type={'warning'}>{value}</Alert>}
                        </TranslatedText>
                      )}

                      <ItemGroup>
                        <TranslatedText i18nKey={'LOGIN_PHONE_GETOTP_LABEL'}>
                          {(value) => (
                            <Button variant="primary" type="submit">
                              {value}
                            </Button>
                          )}
                        </TranslatedText>
                        <TranslatedText i18nKey="LOGIN_PHONE_GETOTP_LABEL">
                          {(value) => (
                            <Link to={'/login'}>
                              <Button onClick={() => window.sessionStorage.removeItem('type')} variant="secondary">
                                Tilbake
                              </Button>
                            </Link>
                          )}
                        </TranslatedText>
                      </ItemGroup>
                    </Layout>
                  </form>
                )}
                {stage === stages.waitingForValidation && (
                  <TranslatedText i18nKey="MAGICLINK_MESSAGE">{(value) => <div>{value}</div>}</TranslatedText>
                )}
              </React.Fragment>
            )
          }}
        </LoginOTP>
      )}
      {type === 'username' && (
        <div>
          <Layout>
            <Center>
              <Logo />
            </Center>
            <Input autoFocus onChange={(e) => setUsername(e.target.value)} id="username" label="Brukernavn" />
            <Input type="password" onChange={(e) => setPassword(e.target.value)} id="password" label="Passord" />
            <Button
              variant="primary"
              onClick={() => {
                window.sessionStorage.setItem('type', 'username')
                submitCredentials()
              }}
            >
              {'Logg inn'}
            </Button>
            {error && <Alert type={'warning'}>{error}</Alert>}
            <Link to={'/login'}>
              <Button onClick={() => window.sessionStorage.removeItem('type')} variant="secondary">
                Tilbake
              </Button>
            </Link>
          </Layout>
        </div>
      )}
    </>
  )
}

const Center = styled.div`
  text-align: center;
  display: flex;
  justify-content: center;
  width: 200px;
`

const CodeMessage = styled.p`
  width: 200px;
  max-width: 100%;
  margin: 0;
  line-height: 1.4;
  overflow-wrap: anywhere;
  white-space: normal;
`

export default Login
